// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".adsbyfalcon[data-v-993d3920]{display:inline-block;overflow:hidden;width:100%;text-align:center}.adsbyfalcon.radius[data-v-993d3920]{border-radius:8px}.adsbyfalcon.sticky[data-v-993d3920]{position:fixed;top:102.5px;z-index:2}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
